var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "transition",
        {
          attrs: {
            name: "fade",
            "enter-active-class": "animated bounceInLeft",
            "leave-active-class": "animated bounceOutLeft"
          }
        },
        [
          _c(
            "md-layout",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showVastTagAlert,
                  expression: "showVastTagAlert"
                }
              ],
              attrs: { "md-flex": "100" }
            },
            [
              _c(
                "md-whiteframe",
                {
                  staticClass: "validation-error-message",
                  attrs: { "md-elevation": "2" }
                },
                [
                  _c("md-icon", {
                    attrs: { "md-iconset": "fa fa-exclamation-triangle" }
                  }),
                  _c("span", [
                    _vm._v(
                      "It is not recommended to use insecure http:// URL for ad tags, as this may cause your ad to not render in some environments.\nPlease use an https:// URL for your ad tag to ensure correct ad functionality."
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "md-layout",
        { attrs: { "md-flex": "100" } },
        [
          _c(
            "md-layout",
            [
              _c(
                "md-input-container",
                {
                  class: {
                    "md-input-invalid":
                      _vm.formSubmitted && _vm.validations.default.$invalid
                  }
                },
                [
                  _c("label", [_vm._v("VAST Tag")]),
                  _c("md-input", {
                    model: {
                      value: _vm.ads.default,
                      callback: function($$v) {
                        _vm.$set(_vm.ads, "default", $$v)
                      },
                      expression: "ads.default"
                    }
                  }),
                  _vm.formSubmitted && _vm.validations.default.$invalid
                    ? _c("span", { staticClass: "md-error" }, [
                        _vm._v("Invalid URL")
                      ])
                    : _vm._e(),
                  _c(
                    "md-layout",
                    { attrs: { "md-flex": "5" } },
                    [
                      _c(
                        "md-icon",
                        {
                          staticClass: "md-primary info-tooltip",
                          attrs: { "md-iconset": "fa fa-info-circle" }
                        },
                        [
                          _c(
                            "md-tooltip",
                            { attrs: { "md-direction": "top" } },
                            [_vm._v("Enter a VAST Tag directly")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.isDefaultVastComplete
        ? _c(
            "md-layout",
            { attrs: { "md-flex": "100" } },
            [
              _c("md-chips", {
                staticClass: "failover",
                attrs: {
                  "md-max": 4,
                  "md-input-placeholder": "VAST TAG Failovers (up to 4)"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(chip) {
                        return [_c("span", [_vm._v(_vm._s(chip.value))])]
                      }
                    }
                  ],
                  null,
                  false,
                  3226392169
                ),
                model: {
                  value: _vm.ads.default_failover,
                  callback: function($$v) {
                    _vm.$set(_vm.ads, "default_failover", $$v)
                  },
                  expression: "ads.default_failover"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "md-layout",
        { attrs: { "md-flex": "100" } },
        [
          _c(
            "transition",
            {
              attrs: {
                name: "fade",
                "enter-active-class": "animated bounceInLeft",
                "leave-active-class": "animated bounceOutLeft"
              }
            },
            [
              _c(
                "md-layout",
                [
                  _c(
                    "md-input-container",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.isDefaultVastComplete &&
                            _vm.isMobilePlatformEnabled,
                          expression:
                            "isDefaultVastComplete && isMobilePlatformEnabled"
                        }
                      ],
                      class: {
                        "md-input-invalid":
                          _vm.formSubmitted && _vm.validations.mobile.$invalid
                      }
                    },
                    [
                      _c("label", [_vm._v("VAST Tag for Mobile")]),
                      _c("md-input", {
                        model: {
                          value: _vm.ads.mobile,
                          callback: function($$v) {
                            _vm.$set(_vm.ads, "mobile", $$v)
                          },
                          expression: "ads.mobile"
                        }
                      }),
                      _vm.formSubmitted && _vm.validations.mobile.$invalid
                        ? _c("span", { staticClass: "md-error" }, [
                            _vm._v("Invalid URL")
                          ])
                        : _vm._e(),
                      _c(
                        "md-layout",
                        { attrs: { "md-flex": "5" } },
                        [
                          _c(
                            "md-icon",
                            {
                              staticClass: "md-primary info-tooltip",
                              attrs: { "md-iconset": "fa fa-info-circle" }
                            },
                            [
                              _c(
                                "md-tooltip",
                                { attrs: { "md-direction": "top" } },
                                [
                                  _vm._v(
                                    "Optionally, provide an alternative VAST Tag for Mobile platforms"
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.isMobilePlatformEnabled && _vm.isMobileVastComplete
        ? _c(
            "md-layout",
            { attrs: { "md-flex": "100" } },
            [
              _c("md-chips", {
                staticClass: "failover",
                attrs: {
                  "md-max": 4,
                  "md-input-placeholder":
                    "VAST TAG for Mobile Failovers (up to 4)"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(chip) {
                        return [_c("span", [_vm._v(_vm._s(chip.value))])]
                      }
                    }
                  ],
                  null,
                  false,
                  3226392169
                ),
                model: {
                  value: _vm.ads.mobile_failover,
                  callback: function($$v) {
                    _vm.$set(_vm.ads, "mobile_failover", $$v)
                  },
                  expression: "ads.mobile_failover"
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50d7dcf6", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50d7dcf6","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/Vast.vue
// module id = 773
// module chunks = 0